$(() => {
  $('.btn-unfocus').focus(function () {
    this.blur();
  });
});
